import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { OrderOverviewAdapter } from './adapters/order-overview.adapter';
import { OccOrderOverviewAdapter } from './adapters/impl/occ-order-overview.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: OrderOverviewAdapter,
            useClass: OccOrderOverviewAdapter,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class OccModule {
}
